/**
 * Formats a number as a currency string based on the provided currency code.
 * @param {number|string} value - The numeric value to format, can be a number or a string (e.g., "35.030,95").
 * @param {string} currency - The currency code (e.g., "BRL", "USD", "EUR").
 * @returns {string} The formatted currency string.
 */
export function formatCurrency(value, currency) {
  // Handle invalid or empty values
  if (value === null || value === undefined || value === "") return "0,00";

  // Parse the value if it's a string; otherwise, use it directly
  let numericValue = typeof value === "number" ? value : 0;

  if (typeof value === "string") {
    // Remove any non-numeric characters except for comma and dot
    let cleanedValue = value.replace(/[^0-9,.]/g, "");

    // Log para depuração
    console.log("formatCurrency input:", value, "cleaned:", cleanedValue);

    // Detect the format based on separators
    if (cleanedValue.includes(",") && cleanedValue.includes(".")) {
      cleanedValue = cleanedValue.replace(/\./g, ""); // Remove thousand separators (dot)
      cleanedValue = cleanedValue.replace(",", "."); // Replace comma with dot
    } else if (cleanedValue.includes(",") && !cleanedValue.includes(".")) {
      cleanedValue = cleanedValue.replace(",", ".");
    } else if (cleanedValue.includes(".") && !cleanedValue.includes(",")) {
      // Already in the correct format for parseFloat
    } else if (cleanedValue.includes(",")) {
      const parts = cleanedValue.split(",");
      const lastPart = parts.pop(); // Última parte (decimal)
      const integerPart = parts.join(""); // Junta as partes inteiras
      cleanedValue = `${integerPart}.${lastPart}`; // "35030.95"
    }

    numericValue = parseFloat(cleanedValue) || 0;
    console.log("formatCurrency parsed:", numericValue);
  }

  // Define locale for number formatting (without currency symbol)
  const locale = currency === "BRL" ? "pt-BR" : "en-US"; // Use "en-US" for both USD and EUR
  const formatter = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  // Format the number without the currency symbol
  const formattedNumber = formatter.format(numericValue);

  // Define the currency symbol and its position
  const currencySymbol = currency === "BRL" ? "R$" : currency === "USD" ? "$" : "€";

  // Always place the symbol before the value, with a space
  return `${currencySymbol} ${formattedNumber}`;
}
